/**
 * Utility class that decorates a link with an event handler that pushes data to the data layer
 */

export default class MainSlider {
  static get links () {
    return document.querySelectorAll('.main-slider .item a:not([data-datalayer-initialized])')
  }

  static get allItems () {
    return document.querySelectorAll('.main-slider .item')
  }

  constructor (link) {
    link.addEventListener('click', this.pushDataToDataLayer(this.createDataForLink(link)))
    link.dataset.datalayerInitialized = 'true'
  }

  rootLinkItem (link) {
    return link.closest('.item').dataset.name
  }

  createDataForLink (link) {
    return {
      event: 'mainSliderClick',
      'mainSliderContent': this.rootLinkItem(link),
    }
  }

  pushDataToDataLayer (data) {
    return () => window.dataLayer.push(data)
  }
}


// WEBPACK FOOTER //
// ./src/modules/datalayer/MainSlider.js